import type Trail from '@alltrails/core/types/Trail';
import type TrailDetails from '@alltrails/core/types/TrailDetails';
import getLocationName from '@alltrails/shared/utils/getLocationName';

const getTrailLocationName = (trail: Trail | TrailDetails) => {
  if (trail.area) {
    return trail.area.name;
  }

  return getLocationName(trail.location);
};

export default getTrailLocationName;
